const DYNAMIC_NAV_ITEM_PATTERNS: Array<[RegExp, string]> = [
  [/^\/admin\/console\//, 'admin-link'],
  [/^\/documents\/entity-types\//, 'entity-type-link'],
  [/^\/dashboards\/.+/, 'dashboard-link'],
  [/^\/search\/.+/, 'saved-search-link'],
];

export function getNavigationAnalyticsItem(pathname: string) {
  if (pathname === '/') return 'home-link';

  const dynamicItem = DYNAMIC_NAV_ITEM_PATTERNS.find(([pattern]) =>
    pattern.test(pathname),
  );
  if (dynamicItem) return dynamicItem[1];

  const pathItem = pathname
    .split(/[?#]/, 1)[0]
    .split('/')
    .filter(Boolean)
    .join('-')
    .toLowerCase();

  return pathItem ? `${pathItem}-link` : 'unknown-link';
}
